import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { aiKeyAdd } from '../../../store/slices/tenantSlices/configurationSlice';
import FormInput from '../../../components/form/FormInput';

const AddAiKeyModal = ({ isOpen, toggle, refreshList }) => {
  const dispatch = useDispatch();

  const initialValues = {
    api_key: ''
  };

  const validationSchema = Yup.object({
    api_key: Yup.string().required('API Key is required')
  });

  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const response = await dispatch(aiKeyAdd(values)).unwrap();
      if (response && response.success) {
        toast.success(response.message || 'Record Added Successfully');
        resetForm();
        toggle();
        refreshList();
      } else {
        toast.error(response?.message || 'Failed to add API Key');
      }
    } catch (err) {
      console.error('Error adding AI key:', err);
    } finally {
      setSubmitting(false);
    }
  };

  const { values, handleChange, handleBlur, handleSubmit, touched, errors, resetForm, isSubmitting } =
    useFormik({
      initialValues,
      validationSchema,
      onSubmit
    });

  return (
    <Modal isOpen={isOpen} size="lg" centered>
      <ModalHeader className="justify-content-center py-2">
        <div className="fs-5">Add AI Key</div>
      </ModalHeader>
      <ModalBody className="px-4">
        <form id="ai-key-form" onSubmit={handleSubmit}>
          <Row>
            <Col lg="12">
              <FormInput
                name="api_key"
                label="API Key"
                placeholder="Enter API Key"
                value={values.api_key}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            toggle();
            resetForm();
          }}
          className="px-5 bg-transparent text-primary"
          disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          form="ai-key-form"
          type="submit"
          className="px-5 bg-primary border-primary"
          disabled={isSubmitting}>
          {isSubmitting ? 'Saving...' : 'Save'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AddAiKeyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  refreshList: PropTypes.func.isRequired
};

export default AddAiKeyModal;
